<div class="single-view-container">
  <div class="header-section">
    <h2>Route Components {{ isGridView ? 'Grid' : 'Vertical' }} View</h2>
    <div class="controls">
      <p class="description">{{ isGridView ? 'Compact grid view' : 'Detailed vertical view' }} of route components</p>
      <div class="button-group">
        <button class="view-toggle" (click)="toggleViewMode()">
          <span class="toggle-icon">{{ isGridView ? '📋' : '⊞' }}</span>
          Switch to {{ isGridView ? 'Vertical' : 'Grid' }} View
        </button>
        <button
          class="pdf-download-button"
          (click)="downloadPdf()"
          [disabled]="isGeneratingPdf"
          [class.loading]="isGeneratingPdf">
          <span class="pdf-icon">📄</span>
          {{ isGeneratingPdf ? 'Generating PDF...' : 'Download PDF' }}
        </button>
      </div>
    </div>
  </div>

  <!-- Grid View -->
  <div class="routes-grid" *ngIf="isGridView && hasLoadedData">
    <div class="route-card"
         *ngFor="let route of routes; let i = index"
         [ngClass]="{'hidden': route.requiresData && !hasData(route.routeName)}"
    >
      <div class="card-header">
        <span class="route-number">{{ i + 1 }}</span>
        <div class="route-info">
          <h4 class="route-name">{{ route.routeName }}</h4>
          <span class="component-badge">{{ route.componentName }}</span>
        </div>
      </div>
      <div class="component-preview">
        <ng-container *ngComponentOutlet="getComponentType(route.componentSelector)"></ng-container>
      </div>
    </div>
  </div>

  <!-- Vertical View -->
  <div class="routes-vertical" *ngIf="!isGridView && hasLoadedData">
    <div class="route-section"
         *ngFor="let route of routes; let i = index"
         [ngClass]="{'hidden': route.requiresData && !hasData(route.routeName)}"
    >
      <div class="route-header">
        <span class="route-number">{{ i + 1 }}</span>
        <h3>{{ route.routeName }}</h3>
        <span class="component-badge">{{ route.componentName }}</span>
      </div>
      <div class="component-container">
        <ng-container *ngComponentOutlet="getComponentType(route.componentSelector)"></ng-container>
      </div>
    </div>
  </div>

  <div class="debug-actions">
    <a routerLink="/debug" class="back-button">Back to Debug Tools</a>
  </div>
</div>
